var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28906 5.04018V2.08005C3.28906 1.76003 3.48804 1.096 4.28395 1H12.7958C13.1152 1.05334 13.7465 1.34401 13.717 2.08005V5.04018",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21891 12.3608C1.78902 12.1474 0.943975 11.4967 1.00293 10.6007V7.08056C1.03978 6.48053 1.43037 5.27248 2.69793 5.24048H14.1576C14.7717 5.32048 16 5.8005 16 7.08056V10.4007C15.9754 10.7341 15.7126 11.5528 14.8577 12.1608",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36523 9.64038H14.5619",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39731 9.64038V16.4407C3.37274 16.734 3.50048 17.3687 4.20796 17.5607H12.683C13.0023 17.6141 13.6631 17.5127 13.7516 16.6807V10.1604",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42383 12.2405H11.5406",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.8008H10.0323",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2793 7.52002H13.6795",
    stroke: "#2E77D0",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePrint);
export default __webpack_public_path__ + "static/media/bluePrint.a63714817e336e1655c20e64e88cc453.svg";
export { ForwardRef as ReactComponent };